export class DocumentManagementEventMessages {
    public static DocumentEntityAccessRequested = "document-entity-access-requested";
}
